import { jsx as _jsx } from "react/jsx-runtime";
const CardInfoActiveIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "100%", height: "100%", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M11.175 17.8416L15 14.025L18.825 17.8416L20 16.6666L15 11.6666L10 16.6666L11.175 17.8416Z", fill: props.color }) })));
};
CardInfoActiveIcon.defaultProps = {
    color: 'white',
};
export default CardInfoActiveIcon;
